module.exports = __webpack_public_path__ + "static/media/IMG_20180810_172518.8ef7f54c.jpg";